import { render, staticRenderFns } from "./citedPushTemplateConfigDetail.vue?vue&type=template&id=664e0fca&scoped=true"
import script from "./citedPushTemplateConfigDetail.vue?vue&type=script&lang=js"
export * from "./citedPushTemplateConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./citedPushTemplateConfigDetail.vue?vue&type=style&index=0&id=664e0fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e0fca",
  null
  
)

export default component.exports